/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import { isNonEmpty } from '../../utils/arrayUtils';
import { TextForm } from '../../components/base/TextForm';
import { useCreateReview } from '../../networking/useReview';
import Loading from '../../components/base/Loading';
import { useSessionState } from '../../utils/usePersistedState';
import { fromReviewResponseToReportResultNode, useGetAnomalies } from './useGetAnomalies';
import { Text } from '../../components/base/Text';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Button } from '../../components/base/Button';
import { ReportAnomalies } from './ReportAnomalies';
export const ReviewTitle = ({ title, dropdDownItems = null, style, }) => {
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'row', gap: 10 } },
        React.createElement(Text, { value: title, style: { fontSize: '1.4vw', fontWeight: 700, ...style } }),
        dropdDownItems && (React.createElement(Dropdown, { menu: { items: dropdDownItems } },
            React.createElement(DownOutlined, null)))));
};
export const TextReview = ({ files, highlights, setHighlights, dropdDownItems, }) => {
    const { isLoading: isLoadingTextReview, data: postReviewResponse, call: callStartReview } = useCreateReview();
    const [currentReview, setCurrentReview] = useSessionState('currentTextReview', null);
    const [query, setQuery] = useSessionState('currentReviewQuery', '');
    const { reportResult, setReportResult } = useGetAnomalies({
        reviewResponse: postReviewResponse,
        setReviewResponse: setCurrentReview,
        setKnwoledgeBaseHighlights: setHighlights,
    });
    /**
     * After the files to review have been uploaded,
     * start the actual review automatically
     */
    useEffect(() => {
        if (currentReview) {
            const reportResultNode = fromReviewResponseToReportResultNode({
                reviewResponse: currentReview,
            });
            setReportResult(reportResultNode.anomalyHighlights);
        }
    }, []);
    const submitQuery = async (query) => {
        if (isNonEmpty(files)) {
            callStartReview({ text_to_review: query, knowledge_base: files.map((f) => f.id) });
            setQuery(query);
        }
    };
    useEffect(() => {
        if (reportResult) {
            const kbHighlights = reportResult.map((a) => a.highlights);
            setHighlights(kbHighlights[0]);
        }
    }, [reportResult]);
    return (React.createElement("div", null,
        React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' } },
            React.createElement(ReviewTitle, { title: "Text to review", dropdDownItems: dropdDownItems }),
            isNonEmpty(highlights) && (React.createElement(Button, { text: "Exit review", style: { width: 150, backgroundColor: 'yellow' }, onClick: () => {
                    setHighlights([]);
                    setReportResult(null);
                    setCurrentReview(null);
                } }))),
        React.createElement("div", { style: { paddingTop: 32 } },
            React.createElement(TextForm, { disabled: !isNonEmpty(files) && !isLoadingTextReview, initialText: query !== 'undefined' ? query : '', placeholder: "Enter your text here. Press Enter to start the review.", handleSubmit: submitQuery, minRows: 15, maxRows: 20, characterLimit: 2048, clearOnSubmit: false }),
            React.createElement("div", { className: "review-result-container" }, isLoadingTextReview ? (React.createElement(Loading, { text: "Reviewing your text...", onlyText: true, style: { fontSize: 14 } })) : reportResult ? (React.createElement("div", { style: { flexGrow: 1, paddingTop: 10 } },
                React.createElement(ReportAnomalies, { reportHighlights: reportResult, setKBHighlights: setHighlights }))) : null))));
};
